import { KOMCOL, MINCOL } from "../../../constants/const"
import JaNeinFilter from "../JaNeinFilter"
import DropdownFilter from "../SD_einsehen/DropdownFilter"

export const aufgabenHeader = [
    {Header: "Themenbereich",
        columns: [
            {accessor: 'description',
            Header: 'Grund',
            width: KOMCOL,
            Filter: DropdownFilter
            },
            {accessor: 'href_ursprung',
            Header: 'Verweis auf Ursprung',
            width: MINCOL
        }
        ],
    },
    {Header: 'zugeordnete Aufgaben',
        columns: [
            {accessor: 'aufgabe',
            Header: 'Beschreibung der Aufgabe',
            width: KOMCOL
        },
            {accessor: 'href_problem',
            Header: 'zu bearbeiten',
            width: MINCOL
        },
            {id: 'erledigt',
            Header: 'ist erledigt',
            accessor: d => d.erledigt ? "ja" : "nein",
            width: MINCOL,
            Filter: JaNeinFilter
        }
        ]
    }
]

//TODO: Spaltenbreiten anpassen, greift nicht auf width zu bei Verschachtelung

export const hiddenColumns = ['id_topic', 'id_aufgabe']